import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  access: [],
  flags: [],
  isSuperAdmin: false,
  isLoaded: false,
};

const rbacSlice = createSlice({
  name: 'rbacSlice',
  initialState,
  reducers: {
    setRbacAccess: (state, action) => {
      state.access = action.payload || [];
    },
    setRbacFlags: (state, action) => {
      state.flags = action.payload || [];
    },
    setRbacIsSuperAdmin: (state, action) => {
      state.isSuperAdmin = Boolean(action.payload);
    },
    setRbacLoaded: (state, action) => {
      state.isLoaded = Boolean(action.payload);
    },
    resetRbacSlice: () => initialState,
  },
});

export const {
  setRbacAccess,
  setRbacFlags,
  setRbacIsSuperAdmin,
  setRbacLoaded,
  resetRbacSlice,
} = rbacSlice.actions;
export default rbacSlice.reducer;
